import { omit, cloneDeep } from 'lodash';
import { ELSCommonUIConstants, ELSLoggingService } from '@els/els-ui-common-react';
var getBrowserDetails = function () { return omit(cloneDeep(navigator), 'mimeTypes'); };
export var ErrorService = {
    log: function (_a) {
        var err = _a.err, previousState = _a.previousState, previousStateParams = _a.previousStateParams;
        var details = {
            error: err,
            browser: getBrowserDetails(),
            previousState: previousState,
            previousStateParams: previousStateParams
        };
        ELSLoggingService.error('ErrorService', details);
    },
    redirect: function (_a) {
        var err = _a.err, previousState = _a.previousState, previousStateParams = _a.previousStateParams;
        var details = {
            error: err,
            browser: getBrowserDetails(),
            previousState: previousState,
            previousStateParams: previousStateParams,
            message: ELSCommonUIConstants.httpStatus.getStatusText(err.status) || 'The application has encountered an unknown error.'
        };
        ELSLoggingService.error('ErrorService', details);
    }
};
export var promiseErrorHandler = function (error) {
    ELSLoggingService.error('', "Invoke service error: ".concat(error.message), error);
    return { data: [] };
};
